import React, { useEffect, useState } from 'react';
import { getShopProducts, addShopProduct, deactivateShopProduct, editShopProduct, deleteShopProduct } from '../services/api';
import { Button, Card, Row, Col, Modal, Form, Alert, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './ShopCard.css';
import './EmptyTipBar.css';

import apiService from '../services/api';

function ShopAdmin() {
  // 用于聚焦提示信息的ref
  const alertRef = React.useRef(null);
  const [products, setProducts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name: '', image: '', points_required: '', description: '', url: '' });
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [loading, setLoading] = useState(true);

  // 编辑modal相关
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [editForm, setEditForm] = useState({ name: '', image: '', points_required: '', description: '', url: '', stock: 0 });
  // 删除确认modal
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletingProduct, setDeletingProduct] = useState(null);

  // 上架modal相关
  const [showActivateModal, setShowActivateModal] = useState(false);
  const [activateProduct, setActivateProduct] = useState(null);
  const [activateStock, setActivateStock] = useState(0);

  // 编辑相关方法
  const handleShowEditModal = (product) => {
    setEditingProduct(product);
    setEditForm({
      name: product.name || '',
      image: product.image || '',
      points_required: product.points_required || '',
      description: product.description || '',
      url: product.url || '',
      stock: product.stock || 0,
    });
    setShowEditModal(true);
    setError('');
    setSuccessMsg('');
  };

  const handleEditChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  const handleEditProduct = async (e) => {
    e.preventDefault();
    if (!editingProduct) return;
    try {
      await editShopProduct(editingProduct.id, editForm);
      setSuccessMsg('商品信息已更新');
      setShowEditModal(false);
      fetchProducts();
    } catch (err) {
      setError(err.response?.data?.message || '修改失败');
    }
  };

  // 删除相关方法
  const handleShowDeleteModal = (product) => {
    setDeletingProduct(product);
    setShowDeleteModal(true);
  };

  const handleDeleteProduct = async () => {
    if (!deletingProduct) return;
    try {
      await deleteShopProduct(deletingProduct.id);
      setSuccessMsg('商品已删除');
      setShowDeleteModal(false);
      fetchProducts();
    } catch (err) {
      setError(err.response?.data?.message || '删除失败');
    }
  };


  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const res = await getShopProducts();
      setProducts(res.data);
    } catch {
      setError('获取商品失败');
    } finally {
      setLoading(false);
    }
  };

  const handleShowModal = () => {
    setShowModal(true);
    setForm({ name: '', image: '', points_required: '', description: '', url: '', stock: 999 });
    setError('');
    setSuccessMsg('');
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAddProduct = async (e) => {
    e.preventDefault();
    try {
      await addShopProduct(form);
      setSuccessMsg('商品添加成功');
      setShowModal(false);
      fetchProducts();
    } catch (e) {
      setError(e.response?.data?.message || '添加失败');
    }
  };

  // 上架商品
  const handleShowActivateModal = (product) => {
    setActivateProduct(product);
    setActivateStock(product.stock || 0);
    setShowActivateModal(true);
    setError('');
    setSuccessMsg('');
  };

  const handleActivateProduct = async (e) => {
    e.preventDefault();
    if (!activateProduct) return;
    try {
      await apiService.activateShopProduct(activateProduct.id, Number(activateStock));
      setSuccessMsg('商品已上架');
      setError('');
      setShowActivateModal(false);
      fetchProducts();
      // 聚焦到提示信息
      setTimeout(() => {
        if (alertRef.current) {
          alertRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
          alertRef.current.focus && alertRef.current.focus();
        }
      }, 200);
    } catch (e) {
      // 控制台调试
      console.error('上架异常', e, e?.response);
      let msg = '上架失败';
      if (e.response) {
        msg = e.response.data?.message || msg;
        // 只追加有意义的对象内容
        if (e.response.data && typeof e.response.data === 'object' && Object.keys(e.response.data).length > 0) {
          msg += ' [' + JSON.stringify(e.response.data) + ']';
        }
        msg += ` (HTTP ${e.response.status})`;
      }
      // 追加异常字符串和 response 字段，便于调试
      msg += '\n' + (e.toString ? e.toString() : '');
      if (e.response) {
        msg += '\nRESPONSE: ' + JSON.stringify(e.response, null, 2);
      }
      setError(msg);
      setSuccessMsg('');
      setShowActivateModal(false);
      setTimeout(() => {
        if (alertRef.current) {
          alertRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
          alertRef.current.focus && alertRef.current.focus();
        }
      }, 200);
    }
  };

  // 下架商品
  const handleDeactivate = async (productId) => {
    try {
      await deactivateShopProduct(productId);
      setSuccessMsg('商品已下架');
      fetchProducts();
    } catch (e) {
      setError(e.response?.data?.message || '下架失败');
    }
  };

  return (
    <div className="container mt-4">
      <h2>积分商城管理</h2>
      <div className="mb-3 d-flex align-items-center">
        <Button className="me-3" onClick={handleShowModal}>添加商品</Button>
        <a href="/admin/shop-orders" className="btn btn-outline-primary position-relative">
          订单管理
          <span id="pending-badge" className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{display:'none'}}>0</span>
        </a>
        <div className="ms-auto">
          <Link to="/admin/system-config" className="btn btn-outline-secondary">系统配置</Link>
        </div>
      </div>
      {(error || successMsg) && (
        <Alert ref={alertRef} tabIndex={-1} variant={error ? 'danger' : 'success'}>
          {error || successMsg}
        </Alert>
      )}
      {/* 上架商品 */}
      <div className="shop-group-title mb-2 mt-4">
        <span className="shop-group-title-icon bg-success"></span>
        <span>上架商品</span>
      </div>
      <Row xs={1} md={2} lg={3} className="g-4 mt-2">
        {products.filter(p => !p.status || p.status === 'active').length === 0 && (
          <div className="empty-tip-bar">暂无上架商品</div>
        )}
        {products.filter(p => !p.status || p.status === 'active').map(product => (
          <Col key={product.id}>
            <Card className="shop-card-fixed-height">
              <div className="shop-card-img">
                <img src={product.image || 'https://via.placeholder.com/300x200?text=No+Image'} alt={product.name} />
              </div>
              <Card.Body className="shop-card-body-fixed-height">
                <div className="shop-card-title" title={product.name}>{product.name}</div>
                <Card.Text>
                  <b>所需积分：</b>{product.points_required}<br/>
                  <b>库存：</b>{product.stock}<br/>
                  <div className="shop-card-desc-row">
                    <span className="shop-card-desc-label">商品介绍：</span>
                    <span className="shop-card-desc-content" title={product.description}>{product.description || '无'}</span>
                  </div>
                  {product.url && <a href={product.url} target="_blank" rel="noopener noreferrer">商品原始链接</a>}<br/>
                </Card.Text>
                <div className="d-flex justify-content-between align-items-center mt-2">
                  <div className="btn-group w-100" role="group">
                    <Button variant="warning" size="sm" className="w-33" onClick={() => handleShowEditModal(product)}>编辑</Button>
                    <Button variant="danger" size="sm" className="w-33" onClick={() => handleShowDeleteModal(product)}>删除</Button>
                    <Button variant="secondary" size="sm" className="w-33" onClick={() => handleDeactivate(product.id)}>下架</Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      {/* 下架商品 */}
      <div className="shop-group-title mb-2 mt-5">
        <span className="shop-group-title-icon bg-secondary"></span>
        <span>下架商品</span>
      </div>
      <Row xs={1} md={2} lg={3} className="g-4 mt-2">
        {products.filter(p => p.status && p.status !== 'active').length === 0 && (
          <div className="empty-tip-bar">暂无下架商品</div>
        )}
        {products.filter(p => p.status && p.status !== 'active').map(product => (
          <Col key={product.id}>
            <Card className="shop-card-fixed-height">
              <div className="shop-card-img">
                <img src={product.image || 'https://via.placeholder.com/300x200?text=No+Image'} alt={product.name} />
              </div>
              <Card.Body className="shop-card-body-fixed-height">
                <div className="shop-card-title" title={product.name}>{product.name}</div>
                <Card.Text>
                  <b>所需积分：</b>{product.points_required}<br/>
                  <b>库存：</b>{product.stock}<br/>
                  <div className="shop-card-desc-row">
                    <span className="shop-card-desc-label">商品介绍：</span>
                    <span className="shop-card-desc-content" title={product.description}>{product.description || '无'}</span>
                  </div>
                  {product.url && <a href={product.url} target="_blank" rel="noopener noreferrer">商品原始链接</a>}<br/>
                  <span className="badge bg-secondary">{product.status === 'inactive' ? '已下架' : product.status}</span>
                </Card.Text>
                <div className="d-flex justify-content-between align-items-center mt-2">
  <div className="btn-group w-100" role="group">
    <Button variant="warning" size="sm" className="w-33" onClick={() => handleShowEditModal(product)}>编辑</Button>
    <Button variant="danger" size="sm" className="w-33" onClick={() => handleShowDeleteModal(product)}>删除</Button>
    <Button variant="success" size="sm" className="w-33" onClick={() => handleShowActivateModal(product)}>上架</Button>
  </div>
</div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* 上架商品Modal */}
      <Modal show={showActivateModal} onHide={() => setShowActivateModal(false)} centered>
        <Form onSubmit={handleActivateProduct}>
          <Modal.Header closeButton>
            <Modal.Title>商品上架</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-2">
              <b>商品名称：</b>{activateProduct?.name}
            </div>
            <Form.Group className="mb-2">
              <Form.Label>库存数量</Form.Label>
              <Form.Control name="activateStock" type="number" value={activateStock} min={0} onChange={e => setActivateStock(e.target.value)} required />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowActivateModal(false)}>取消</Button>
            <Button variant="primary" type="submit">确认上架</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* 编辑商品Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
        <Form onSubmit={handleEditProduct}>
          <Modal.Header closeButton>
            <Modal.Title>编辑商品</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-2">
              <Form.Label>商品名</Form.Label>
              <Form.Control name="name" value={editForm.name} onChange={handleEditChange} required />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>图片URL</Form.Label>
              <Form.Control name="image" value={editForm.image} onChange={handleEditChange} />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>所需积分</Form.Label>
              <Form.Control name="points_required" type="number" value={editForm.points_required} onChange={handleEditChange} required />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>商品介绍</Form.Label>
              <Form.Control name="description" value={editForm.description} onChange={handleEditChange} as="textarea" />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>库存数量</Form.Label>
              <Form.Control name="stock" type="number" value={editForm.stock} onChange={handleEditChange} min={0} required />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>商品原始URL</Form.Label>
              <Form.Control name="url" value={editForm.url} onChange={handleEditChange} />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>取消</Button>
            <Button variant="primary" type="submit">保存修改</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* 删除商品确认Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>确认删除商品</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          确定要删除商品“{deletingProduct?.name}”吗？此操作不可撤销。
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>取消</Button>
          <Button variant="danger" onClick={handleDeleteProduct}>确认删除</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Form onSubmit={handleAddProduct}>
          <Modal.Header closeButton>
            <Modal.Title>添加商品</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-2">
              <Form.Label>商品名</Form.Label>
              <Form.Control name="name" value={form.name} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>图片URL</Form.Label>
              <Form.Control name="image" value={form.image} onChange={handleChange} />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>所需积分</Form.Label>
              <Form.Control name="points_required" type="number" value={form.points_required} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>商品介绍</Form.Label>
              <Form.Control name="description" value={form.description} onChange={handleChange} as="textarea" />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>库存数量</Form.Label>
              <Form.Control name="stock" type="number" value={form.stock} onChange={handleChange} min={0} required />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>商品原始URL</Form.Label>
              <Form.Control name="url" value={form.url} onChange={handleChange} />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>取消</Button>
            <Button variant="primary" type="submit">提交</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

// 分组标题样式
const shopGroupTitleStyle = `
.shop-group-title {
  display: flex;
  align-items: center;
  font-size: 1.18em;
  font-weight: 600;
  color: #333;
  letter-spacing: 1px;
  margin-bottom: 0.5em;
}
.shop-group-title-icon {
  display: inline-block;
  width: 8px;
  height: 24px;
  border-radius: 4px;
  margin-right: 12px;
  background: #ccc;
}
.shop-group-title-icon.bg-success {
  background: #18bc9c;
}
.shop-group-title-icon.bg-secondary {
  background: #6c757d;
}
`;

// 动态插入分组标题样式
if (typeof document !== 'undefined' && !document.getElementById('shop-group-title-style')) {
  const style = document.createElement('style');
  style.id = 'shop-group-title-style';
  style.innerHTML = shopGroupTitleStyle;
  document.head.appendChild(style);
}

export default ShopAdmin;
